import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./Home/Home";
import Search from "./Search/Search";
import Services from "./components/Sections/Specialization/Services";
import Contact from "./components/Sections/Contact/Contact";
import { Box, CssBaseline } from "@mui/material";
import NavBar from "./components/NavBar/NavBar";
import Footer from "./components/Footer/Footer";
import OurPrice from "./components/price/OurPrice";
import Gallery from "./components/gallery/Gallery";
import Privacy from "./components/PrivacyPolicy/Privacy";
import GeneralEmergencyCare from "./components/General & Emergency Care/General&EmergencyCare";
import MinorSurgeries from "./components/Minor surgeries/Minorsurgeries";
import Diagnostics from "./components/ECG, USG, X-ray, CT, MRI/ECG_USG_X-ray_ CT_MRI";
import BloodTests from "./components/Blood tests/Bloodtests";
import HomeVisitInjections from "./components/Home visit & Injections/Homevisit&Injections";
import BlogPage from "./components/Sections/Blogs/BlogPage";
import SpecialistDetailPage from "./components/Sections/Specialists/SpecialistDetailPage";
import ScrollToTop from "./components/ScrollToTop";
import ServicesDetail from "./components/Sections/Specialization/ServicesDetail";
import ReviewsDetailContent from "./components/Sections/Reviews/ReviewsDetailContent";

const App = () => {
    return (
        <>
            <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", }}>
                <NavBar />
                <CssBaseline />
                <ScrollToTop />
                <Box component="main" sx={{ flex: 1 }}>
                    <Routes>
                        <Route path="*" element={<ScrollToTop />} />
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<Search />} />
                        <Route path="/price" element={<OurPrice />} />
                        <Route path="/gallery" element={<Gallery />} />
                        <Route path="/privacy" element={<Privacy />} />
                        <Route path="/services" element={<Services />} />
                        <Route path="/general-emergency-care" element={<GeneralEmergencyCare />} />
                        <Route path="/minor-surgeries" element={<MinorSurgeries />} />
                        <Route path="/diagnostics" element={<Diagnostics />} />
                        <Route path="/blood-tests" element={<BloodTests />} />
                        <Route path="/home-visit-injections" element={<HomeVisitInjections />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/blog/*" element={<BlogPage />} />
                        <Route exact path="/specialist/:id/:slug" element={<SpecialistDetailPage />} />
                        <Route exact path="/services/:id/:slug" element={<ServicesDetail />} />
                        <Route exact path="/reviews/:id" element={<ReviewsDetailContent />} />
                    </Routes>
                </Box>
                <Footer />
            </Box>
        </>
    );
};

export default App;
